export const FIX_REALTIME_DRIVER_MARKER_LOCATION_FF = 'fix_realtime_driver_marker_location';
